<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoEditar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoEditar">
            <form (keypress)="ocultarMensagem()" #f="ngForm" name="form" novalidate>
                <div class="formgroup">
                    <div class="flex justify-content-center" *ngIf="exibirSpinner">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div *ngIf="messagemVisivel" class="w-full">
                        <p-messages
                            [(value)]="messages"
                            [enableService]="false"
                            [closable]="true"
                        ></p-messages>
                    </div>
                    <div class="p-fluid p-formgrid grid" *ngIf="tipoPagamento && !exibirSpinner">
                        <div class="field col-12 md:col-3">
                            <label htmlFor="descricao">Descrição</label>
                            <div class="p-inputgroup">
                                <input
                                    oninput="this.value = this.value.toUpperCase();"
                                    type="text"
                                    pInputText
                                    placeholder="Descrição"
                                    name="descricao"
                                    ngModel
                                    [(ngModel)]="tipoPagamento.descricao"
                                    #descricao="ngModel"
                                    required
                                    [disabled]="!descAtiva || !modoEdicao"
                                />
                                <button
                                    type="button"
                                    pButton
                                    pRipple
                                    *ngIf="modoEdicao"
                                    [icon]="iconeLock ? 'pi pi-lock' : 'pi pi-lock-open'"
                                    styleClass="p-button-success"
                                    (click)="ativaDescricao()"
                                    style="box-shadow: none"
                                ></button>
                            </div>
                            <div
                                *ngIf="descricao.hasError('required') && descricao.touched"
                                class="alerta"
                            >
                                <small>Campo obrigatório</small>
                            </div>
                        </div>

                        <div class="field col-12 md:col-3">
                            <label htmlFor="operacao">Operação</label>
                            <p-dropdown
                                *ngIf="tipoPagamento.operacao?.status === true; else labelOperacao"
                                [options]="operacoes"
                                optionLabel="label"
                                optionValue="value"
                                name="operacao"
                                ngModel
                                #operacao="ngModel"
                                [(ngModel)]="tipoPagamento.operacao"
                                [required]="true"
                                [disabled]="!itensDescAtiva || !modoEdicao"
                                (onChange)="mudouDescricao()"
                            ></p-dropdown>
                            <ng-template #labelOperacao>
                                <label class="form-control">
                                    {{ tipoPagamento.operacao?.descricao }}
                                </label>
                                <small class="alerta">Operação não está ativa</small>
                            </ng-template>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="bandeira">Bandeira</label>
                            <p-dropdown
                                [options]="bandeiras"
                                name="bandeira"
                                ngModel
                                #bandeira="ngModel"
                                [(ngModel)]="tipoPagamento.bandeira"
                                [required]="true"
                                [disabled]="!itensDescAtiva || !modoEdicao"
                                (onChange)="mudouDescricao()"
                            ></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="transacao">Transação</label>
                            <p-dropdown
                                [options]="transacoes"
                                name="transacao"
                                ngModel
                                #transacao="ngModel"
                                [(ngModel)]="tipoPagamento.transacao"
                                [required]="true"
                                [disabled]="!itensDescAtiva || !modoEdicao"
                                (onChange)="mudouDescricao()"
                            ></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label>Meio Pagamento</label>
                            <p-dropdown
                                [options]="meiosPagamento"
                                optionLabel="descricao"
                                placeholder="Selecione"
                                name="meioPagamentoTributario"
                                #meioPagamentoTributario="ngModel"
                                [(ngModel)]="tipoPagamento.meioPagamentoTributario"
                                [required]="true"
                            ></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="antencipacao">Antecipação</label>
                            <p-inputNumber
                                [(ngModel)]="tipoPagamento.antecipacao"
                                name="antencipacao"
                                mode="decimal"
                                [disabled]="!modoEdicao"
                                mode="decimal"
                                [max]="100"
                                [minFractionDigits]="2"
                                [maxFractionDigits]="2"
                                suffix="%"
                            ></p-inputNumber>
                        </div>
                    </div>

                    <div class="container card col-12" *ngIf="tipoPagamento && !exibirSpinner">
                        <h5>Parcelas</h5>
                        <div class="components p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-3">
                                <label htmlFor="quantidadeParcelas">Insira a quantidade</label>
                                <input
                                    pInputText
                                    type="number"
                                    name="quantidadeParcelas"
                                    [(ngModel)]="qtdParcelas"
                                />
                            </div>
                            <div class="field col-12 md:col-2">
                                <button
                                    pButton
                                    pRipple
                                    label="Adicionar"
                                    class="p-button-success mt-5"
                                    icon="pi pi-check"
                                    (click)="gerarParcelas()"
                                    style="box-shadow: none"
                                    type="button"
                                    [disabled]="qtdParcelas < 1 || !modoEdicao"
                                ></button>
                            </div>
                        </div>

                        <p-table
                            #dt1
                            [value]="parcelas"
                            dataKey="id"
                            [rows]="10"
                            [rowHover]="true"
                            [paginator]="false"
                            responsiveLayout="scroll"
                            styleClass=" p-datatable-sm"
                        >
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>
                                        <div>Parcela</div>
                                    </th>
                                    <th>
                                        <div>Prazo</div>
                                    </th>
                                    <th>
                                        <div>Taxa Operadora</div>
                                    </th>
                                    <th>
                                        <div>Status</div>
                                    </th>
                                    <th>
                                        <div>Excluir</div>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item let-i="rowIndex">
                                <tr>
                                    <td>
                                        {{ item.quantidadeParcelas }}
                                    </td>
                                    <td>
                                        <input
                                            class="p-inputtext"
                                            type="number"
                                            pInputText
                                            name="prazo{{ i }}"
                                            [(ngModel)]="item.prazo"
                                            [disabled]="!modoEdicao"
                                        />
                                    </td>
                                    <td>
                                        <p-inputNumber
                                            [(ngModel)]="item.descontoFinanceira"
                                            suffix="%"
                                            name="desconto{{ i }}"
                                            mode="decimal"
                                            [max]="100"
                                            [minFractionDigits]="2"
                                            [maxFractionDigits]="2"
                                            [disabled]="!modoEdicao"
                                        ></p-inputNumber>
                                    </td>
                                    <td>
                                        <p-inputSwitch
                                            name="status{{ i }}"
                                            [(ngModel)]="item.status"
                                            [disabled]="!modoEdicao"
                                        ></p-inputSwitch>
                                    </td>

                                    <td>
                                        <button
                                            pButton
                                            pRipple
                                            pTooltip="Excluir"
                                            type="button"
                                            icon="pi pi-trash"
                                            (click)="excluirParcela(item)"
                                            class="p-button-danger mt-5"
                                            [disabled]="i !== parcelas.length - 1 || !modoEdicao"
                                        ></button>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="7">Nenhum registro cadastrado.</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>

                    <div
                        class="p-fluid p-formgrid grid justify-content-between"
                        *ngIf="!exibirSpinner"
                    >
                        <div class="col-12 md:col-4">
                            <button
                                *ngIf="!progressoRequisicao; else exibirBotaoFalso"
                                type="button"
                                pButton
                                icon="pi pi-check"
                                label="Atualizar"
                                (click)="atualizar()"
                                class="p-button-outlined p-button-success md:w-9rem"
                                [disabled]="!f.valid"
                            ></button>
                            <ng-template #exibirBotaoFalso>
                                <button
                                    type="submit"
                                    pButton
                                    icon="pi pi-spin pi-spinner"
                                    label="Atualizar"
                                    class="p-button-outlined p-button-success md:w-9rem"
                                    disabled
                                ></button>
                            </ng-template>
                        </div>
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined md:w-9rem"
                                routerLink="/apps/tipo-pagamento"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
            <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
        </div>
    </div>
</div>
